import { dataSourceApi } from "src/services/settings/dataSource";
import { AUTHENTICATE, CREATE, DATA_SOURCE, DELETE, FETCH, MIGRATE, RSS, STORAGE_LIMIT } from "../queryKeys";
import { useMutationBuilder, useQueryBuilder } from "../useBuilders";
import { DataSource } from "src/types/settings/dataSource";

export const useDataSourceQuery = () => {
  return useQueryBuilder([DATA_SOURCE, FETCH], async () => {
    const data = await dataSourceApi.fetchDataSource();
    return data as DataSource[];
  });
};

export const useMigrateSource = () => {
  return useMutationBuilder(
    [DATA_SOURCE, MIGRATE],
    async (sourceId: string) => {
      const data = await dataSourceApi.migrateDataSource(sourceId);
      return data;
    }
  );
};

export const useCreateRssDataSource = () => {
  return useMutationBuilder<DataSource, { sourceType: string; rssUrl: string }>(
    [RSS, CREATE],
    ({ sourceType, rssUrl }) => dataSourceApi.createRssDataSource(sourceType, rssUrl),
    [DATA_SOURCE, FETCH]
  );
};

export const useAuthenticateDataSource = () => {
  return useMutationBuilder<DataSource, { sourceType: string; code: string }>(
    [DATA_SOURCE, AUTHENTICATE],  
    ({ sourceType, code }) =>
      dataSourceApi.authenticateDataSource(sourceType, code),
    [DATA_SOURCE]
  );
}

export const useDeleteDataSource = () => {
  return useMutationBuilder<void, { id: string }>(
    [DATA_SOURCE, DELETE],
    ({ id }) => dataSourceApi.deleteDataSource(id),
    [DATA_SOURCE]
  );
};

export const useFetchAssetStorageLimit = () => {
  return useQueryBuilder([STORAGE_LIMIT, FETCH], async () => {
    const data = await dataSourceApi.fetchAssetStorageLimit();
    return data;
  });
};




